import React from "react"
import {
  th,
  td,
  tableWrapper,
  table as tableClass,
  thead,
  tr,
} from "./table.module.css"

const Table = ({ data }) => {
  const table = data.tableData
  const headerRow = data.headerRow
  const headerColumn = data.headerColumn

  const getColumns = (columns, isTh) => {
    return columns.map((column, index) => {
      if ((columns && index === 0 && headerColumn) || isTh)
        return (
          <th key={`th-${index}`} className={th}>
            {column}
          </th>
        )
      else
        return (
          <td key={`td-${index}`} className={td}>
            {column}
          </td>
        )
    })
  }

  return (
    <div className={tableWrapper}>
      <table className={tableClass}>
        {table[0] && headerRow && (
          <thead className={thead}>
            <tr className={tr}>{getColumns(table[0], true)}</tr>
          </thead>
        )}
        <tbody className="tbody">
          {table
            .filter((row, index) => (index > 0 && headerRow) || !headerRow)
            .map((row, index) => {
              return (
                <tr key={`tr-${index}`} className={tr}>
                  {getColumns(row)}
                </tr>
              )
            })}
        </tbody>
      </table>
    </div>
  )
}

export default Table
